import { absolute, relative, useClock } from '../lib/time';

export function RelativeTime({ at, className }: { at: string; className?: string }) {
  const now = useClock();
  return (
    <time
      dateTime={at}
      title={absolute(at)}
      className={className ?? 't-caption faint'}
      style={{ whiteSpace: 'nowrap' }}
    >
      {relative(at, now)}
    </time>
  );
}
